import {
  HeartPulse,
  Rose,
  ShieldAlert,
  Ribbon,
  GraduationCap,
  PawPrint,
  Leaf,
  Store,
  Users,
  Trophy,
  Palette,
  CalendarDays,
  Sunrise,
  UsersRound,
  Dumbbell,
  Luggage,
  HandHeart,
  Sparkles,
  type LucideIcon,
} from "lucide-react"

export interface Category {
  id: number
  label: string
  slug: string
  icon: LucideIcon
}

export const CATEGORIES: Category[] = [
  { id: 1, label: "Medical", slug: "medical", icon: HeartPulse },
  { id: 2, label: "Memorial", slug: "memorial", icon: Rose },
  { id: 3, label: "Emergency", slug: "emergency", icon: ShieldAlert },
  { id: 4, label: "Nonprofit", slug: "nonprofit", icon: Ribbon },
  { id: 5, label: "Education", slug: "education", icon: GraduationCap },
  { id: 6, label: "Animal", slug: "animal", icon: PawPrint },
  { id: 7, label: "Environment", slug: "environment", icon: Leaf },
  { id: 8, label: "Business", slug: "business", icon: Store },
  { id: 9, label: "Community", slug: "community", icon: Users },
  { id: 10, label: "Competition", slug: "competition", icon: Trophy },
  { id: 11, label: "Creative", slug: "creative", icon: Palette },
  { id: 12, label: "Event", slug: "event", icon: CalendarDays },
  { id: 13, label: "Faith", slug: "faith", icon: Sunrise },
  { id: 14, label: "Family", slug: "family", icon: UsersRound },
  { id: 15, label: "Sports", slug: "sports", icon: Dumbbell },
  { id: 16, label: "Travel", slug: "travel", icon: Luggage },
  { id: 17, label: "Volunteer", slug: "volunteer", icon: HandHeart },
  { id: 18, label: "Wishes", slug: "wishes", icon: Sparkles },
]

export const CATEGORY_BY_ID = new Map(CATEGORIES.map((c) => [c.id, c]))
export const CATEGORY_BY_SLUG = new Map(CATEGORIES.map((c) => [c.slug, c]))
